// NotificationMarquee.jsx
import React from "react";
import "./Notification.css";

const NotificationMarquee = () => {
  return (
    <div className="bg-primary text-white py-2 overflow-hidden my-5">
      <div className="marquee">

        
        <span> 📢 Rescheduling requests will not be entertained. Please do not contact us regarding schedule changes. </span>
        
        <span>
          📢 CRC registration for authors is now open. Please complete the registration as soon as possible. For any issues, please email <strong>netcrypt2026@gmail.com</strong>.
        </span>

        <span>
          📢 Decisions for most papers have been released. If you encounter any issues during the registration process, please email your query to <strong>netcrypt2026@gmail.com</strong>.
        </span>
      </div>
    </div>
  );
};

export default NotificationMarquee;